import styled from 'styled-components';

export const EsgContentWrapper = styled.div`
    display: grid;
    gap: 24px;
    grid-template-columns: repeat(3, 1fr);
`;
